import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setAppLanguage } from 'src/store/app';

import { CustomButton } from '../CustomButton/CustomButton';

import { APP_LANGUAGES } from 'src/constants';

import { ReactComponent as LanguageIcon } from 'src/assets/header/LanguageIcon.svg';
import './languageDropdown.scss';
import classNames from 'classnames';

export const LanguageDropdown = ({ onSelect }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const menuRef = useRef();

  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'en');
  const [isDropdown, setIsDropdown] = useState(false);

  useEffect(() => {
    i18n.changeLanguage(language);

    localStorage.setItem('language', language);

    dispatch(setAppLanguage({ lang: language }));
  }, [dispatch, i18n, language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  const onClickButton = useCallback(() => {
    setIsDropdown((prev) => !prev);
  }, []);

  const onSelectLanguage = useCallback(
    (lang) => () => {
      setLanguage(lang);
      setIsDropdown(false);

      if (onSelect) {
        onSelect();
      }
    },
    [onSelect],
  );

  const menuStyles = classNames('language-dropdown__menu', {
    'language-dropdown__menu--active': isDropdown,
  });

  return (
    <div className="language-dropdown">
      <CustomButton
        variant="filled"
        color="default"
        icon={<LanguageIcon />}
        title={language?.toUpperCase()}
        onClick={onClickButton}
      />
      <div className={menuStyles} ref={menuRef}>
        {APP_LANGUAGES.map((item) => (
          <div
            key={`perPage-${item.language}`}
            className={`dropdown-item ${item.language === language ? 'active' : ''}`}
            onClick={onSelectLanguage(item.language)}
          >
            {item.language?.toUpperCase()}
          </div>
        ))}
      </div>
    </div>
  );
};
